/* eslint-disable object-curly-newline */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable padded-blocks */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/camelcase */
/* global $ */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

// eslint-disable-next-line func-names
(function (angular) {

    angular.module('app')
        .controller('pwaController', pwaController);

    pwaController.$inject = [
        '$interval',
        'HeartbeatApi',
        'heartbeat',
        'thisUser',
        'thisSiteSettings',
        'thisSite',
    ];

    function pwaController(
        $interval,
        HeartbeatApi,
        heartbeat,
        thisUser,
        thisSiteSettings,
        thisSite,
    ) {
        var vm = this;

        if (!thisUser) {
            return;
        }

        vm.heartbeat = heartbeat;

        vm.pwa_activated = thisSiteSettings.display_pwa_style ?? false;
        vm.pwa_manifest = {};

        function enableTwitterFeedScrolling() {
            const twFeed = document.querySelector('.grid-item #twitter-widget-0');
            if (!twFeed) return false;

            twFeed.setAttribute('scrolling', 'yes');
            return true;
        }

        function initFilterBoxesForDevice() {
            const filterBox = document.querySelector('.toggle-el, .box-o-filters');
            if (!filterBox) return;

            // if (window.innerWidth < 500) {
            //     // $(filterBox).siblings('input.hide-input').first() could be an improvement here
            //     const chkbox = $(filterBox).parent().find('input.hide-input:first-of-type');
            //     const label = $(filterBox).parent().find('label:first-of-type');
            //     if (!chkbox.prop('checked')) {
            //         chkbox.prop('checked', true);
            //         label.find('i').toggleClass('fa-chevron-down fa-chevron-up');
            //     }
            // }
        }

        function initPwaManifest() {
            // Potential strategy for launching quick PWA manifest changes (works with resources/ts/pwa/index.ts)
            // const manifestUpdate = localStorage.getItem('UPDATED_MANIFEST');
            // const updatedManifest = JSON.parse(manifestUpdate);

            // if (updatedManifest) {
            //     localStorage.removeItem('UPDATED_MANIFEST');
            // }

            const {
                is_events_active,
                is_forum_active,
                is_polls_active,
                is_surveys_active,
                is_promotions_active,
                is_resources_active,
            } = thisSite;

            const {
                color_primary,
                pwa,
                site_welcome_msg,
            } = thisSiteSettings;

            const pwaIconSrc = pwa.icon ? `${pwa.icon_url}` : '/img/pwa/default-icon-512x512.png';
            const hostname = `${window.location.protocol}//${thisSite.hostname}/`;

            vm.pwa_manifest = {
                name: thisSiteSettings.pwa_app_name ?? thisSite.name,
                short_name: thisSiteSettings.pwa_app_name ?? thisSite.name,
                description: site_welcome_msg,
                display: 'standalone',
                start_url: hostname,
                background_color: color_primary,
                theme_color: color_primary,
                icons: [
                    {
                        src: pwaIconSrc,
                        sizes: '144x144',
                        type: 'image/png',
                        purpose: 'any',
                    },
                ],
                shortcuts: [],
            };

            type PwaShortcutIconData = {
                src: string;
                sizes?: string;
            };

            function setPwaShortcut(name: string, shortName: string, path: string, icons: PwaShortcutIconData[] = [], description = '') {
                vm.pwa_manifest.shortcuts.push({
                    name,
                    short_name: shortName || name,
                    url: `${window.location.protocol}//${thisSite.hostname}/` + (path.startsWith('/') ? path : `/${path}`),
                    icons,
                    description,
                });
            }

            if (is_events_active) setPwaShortcut('Events', '', '/events', [{ src: 'https://via.placeholder.com/192', sizes: '192x192' }], 'View Events');
            if (is_promotions_active) setPwaShortcut('Offers', '', '/promotions', [{ src: 'https://via.placeholder.com/192', sizes: '192x192' }], 'View Offers');
            if (is_forum_active) setPwaShortcut('Forums', '', '/forum', [{ src: 'https://via.placeholder.com/192', sizes: '192x192' }], 'View Forums');
            if (is_resources_active) setPwaShortcut('Resources', '', '/resources', [{ src: 'https://via.placeholder.com/192', sizes: '192x192' }], 'View Resources');
            if (is_polls_active) setPwaShortcut('Polls', '', '/polls', [{ src: 'https://via.placeholder.com/192', sizes: '192x192' }], 'View Polls');
            if (is_surveys_active) setPwaShortcut('Surveys', '', '/surveys', [{ src: 'https://via.placeholder.com/192', sizes: '192x192' }], 'View Surveys');

            const stringManifest = JSON.stringify(vm.pwa_manifest);
            const blob = new Blob([stringManifest], { type: 'application/json' });
            const manifestURL = URL.createObjectURL(blob);
            const manifestEl = document.querySelector('link[rel="manifest"]');
            if (manifestEl !== null) {
                manifestEl.setAttribute('href', manifestURL);
            }

            // if ('serviceWorker' in navigator) {
            //     navigator.serviceWorker.getRegistrations().then((registrations) => {
            //         // console.log(registrations);
            //         if (registrations.length) {
            //             window?.showInstallPrompt();
            //         }
            //     });
            // }
        }

        function init() {
            initFilterBoxesForDevice();

            if (document.body.classList.contains('homepage')) {
                enableTwitterFeedScrolling();
            }

            // this will need to be changed over to the new PWA hook at some point
            if (thisSiteSettings.display_pwa_style) {
                initPwaManifest();

                window.addEventListener('offline', () => document.body.classList.add('offline'));
                window.addEventListener('online', () => document.body.classList.remove('offline'));
            }

            return true;
        }

        window.addEventListener('load', init);

        $interval(function () {
            HeartbeatApi.get(function (resp) {
                vm.heartbeat = resp.data;
            });
        }, 60000);
    }

}(angular));
